// Module
var code = "<div> <div class=\"button is-small is-primary\" gridAction=\"export\">Export CSV</div> </div> ";
// Exports
export default code;